import type { RibbonFlyoutAnchorProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { RibbonGroupId } from 'owa-ribbon-ids';

export const getMLRFolderTabCommonGroupFlyout: (
    _groupId: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
) => RibbonFlyoutAnchorProps | undefined = owaComputedFn(function getMLRFolderTabCommonGroupFlyout(
    _groupId: RibbonGroupId,
    _props: ReadOnlyRibbonControlDefProps
): RibbonFlyoutAnchorProps | undefined {
    // Folder tab has no commonGroupFlyouts
    return undefined;
});
